function updateTimer(timerElement, saleEndTimeAttribute) {
  const endDate = new Date(saleEndTimeAttribute).getTime();
  const currentDate = new Date().getTime();
  const timeLeft = endDate - currentDate;

  if (timeLeft <= 0) {
    timerElement.innerHTML = "Sale Ended!";
  } else {
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Function to add leading zero if the number is less than 10
    const formatTime = (num) => (num < 10 ? "0" + num : num);

    // Building the timer display with labels on top and values below
    let timerText = `<div style="display:none; text-align: center; margin-right:1px;">
                                <div class="thetime">${formatTime(days)}d</div>
                             </div>
                             <div style="display: inline-block; text-align: center; margin-right:1px;">
                                <div class="thetime">${formatTime(hours)}h</div>
                             </div>
                             <div style="display: inline-block; text-align: center; margin-right:1px;">
                                <div class="thetime">${formatTime(
                                  minutes
                                )}m</div>
                             </div>
                             <div style="display: inline-block; text-align: center;">
                                <div class="thetime">${formatTime(
                                  seconds
                                )}s</div>
                             </div>`;

    timerElement.innerHTML = timerText;
  }
}

// Update the timer for each element with the "offertimer" class
const timerElements = document.querySelectorAll(".offertimer");
const saleEndTimes = document.querySelectorAll(".sale-end-time");

function updateAllTimers() {
  timerElements.forEach((element, index) => {
    const saleEndTimeAttribute =
      saleEndTimes[index].getAttribute("data-end-time");
    updateTimer(element, saleEndTimeAttribute);
  });
}

// Initial call to set up the timers
updateAllTimers();

// Update the timers every second
setInterval(updateAllTimers, 1000);
